/* 
 * AbstractDebugView.js
 * Created on 30-nov-2016
 * @author Swen Meeuwes for &ranj
 */
export default class AbstractDebugView {
    constructor(keyCode, htmlUrl, windowTitle, windowParameters) {
        this._keyCode = keyCode;
        this._htmlUrl = htmlUrl;
        this._windowTitle = windowTitle;
        this._windowParameters = windowParameters;

        this._parentWindow;
        this._gui;
        
        if (this._keyCode) {
            this._handleKeyPressBound = this._handleKeyPress.bind(this);
            window.addEventListener("keypress", this._handleKeyPressBound);
        }
    }

    destroy() {
        if (this._keyCode)
            window.removeEventListener("keypress", this._handleKeyPressBound);

        if (this._parentWindow)
            this._parentWindow.removeEventListener("unload", this._onUnloadBound);
    }

    _handleKeyPress({ keyCode }) {
        if (keyCode === this._keyCode)
            this.showPopup();
    }

    showPopup() {
        if (this._gui)
            this.closePopup();

        this._gui = window.open(this._htmlUrl, this._windowTitle, this._windowParameters);
        this._parentWindow = this._gui.opener;

        this._gui.moveTo(0, 200);
        this._parentWindow.focus();

        this._onUnloadParentBound = this.onUnloadParent.bind(this);
        this._parentWindow.addEventListener("unload", this._onUnloadParentBound);

        this._onLoadBound = this.onLoad.bind(this);
        this._gui.addEventListener("load", this._onLoadBound);
    }

    closePopup() {
        if (this._gui)
            this._gui.close();
    }

    onLoad() {

    }

    onUnloadParent() {
        this.closePopup();
        this.destroy();
    }
}

